export enum WeatherFetchStatus {
  Idle = 0,
  Loading = 1,
  Applied = 2,
  NoData = 3,
  Error = 4,
}
